import React from 'react';
import { playerTypes, wonSet } from '../../../utils';
import { OutComeTypes, WalkOverValues } from '../../../utils/postScoreConstants';
import { titleCase } from '../../../utils/formatting';

const Scores = props => {
    const {
        score,
        playerType,
        showMatchWinner,
        outcome,
        completionType,
        'data-testid': dataTestId,
    } = props;

    if (score && playerType) {
        const scoreArray = Object.values(score);
        if (scoreArray.length > 0) {
            return (
                <>
                    {scoreArray.map((scoreItem, i) => {
                        return (
                            <div
                                className={`score-item ${showMatchWinner(outcome, completionType) ? wonSet(scoreItem, playerType) ? 'winner' : '' : ''}`}
                                key={`score-item-${i}`}
                                data-testid={dataTestId && `${dataTestId}.score-${i}`}
                            >
                                {playerType === playerTypes.WINNER ? scoreItem.winner ? scoreItem.winner : 0 : scoreItem.loser ? scoreItem.loser : 0}
                                {(scoreItem.tiebreak != null && scoreItem.tiebreak >= 0) && (
                                    <sup data-testid={dataTestId && `${dataTestId}.score-${i}.tiebreak`}>{playerType === playerTypes.WINNER ? scoreItem.winnerTiebreak : scoreItem.tiebreak}</sup>
                                )}
                            </div>
                        );
                    })}
                </>
            );
        }
        if (playerType === playerTypes.LOSER && (WalkOverValues.includes(outcome) || completionType === 'winnerdidnotstart') && outcome !== OutComeTypes.ABANDONED && outcome !== OutComeTypes.DOUBLEWALKOVER) {
            return (
                <span className="outcome-font" data-testid={dataTestId && `${dataTestId}.outcome`}>{titleCase(outcome) || 'Walkover'}</span>
            );
        }
    }

    return null;
};

Scores.defaultProps = {
    'data-testid': null,
};

export default Scores;
